import React, { Component } from "react";
import Helmet from "react-helmet";
import firebase from "firebase";
import firebaseui from "firebaseui";
import "firebaseui/dist/firebaseui.css";

import Header from "../components/Header";
import "./Login.css";

class Login extends Component {
  constructor(props) {
    super(props);
    this.firebaseUIContainer = null;

    // FirebaseUI config.
    this.uiConfig = {
      signInSuccessUrl: "/",
      signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
      // Terms of service url.
      tosUrl: "/tos"
    };
    this.firebaseUI = new firebaseui.auth.AuthUI(firebase.auth());
  }

  componentDidMount() {
    // The start method will wait until the DOM is loaded.
    this.firebaseUI.start(this.firebaseUIContainer, this.uiConfig);
  }

  render() {
    return (
      <div className="type-page-container">
        <Helmet>
          <title>Login to wiki</title>
        </Helmet>
        <div className="type-page-content">
          <Header isPageLoaded={true} />
          <div className="type-login-container">
            <h2>Select an account to login</h2>
            <div ref={el => (this.firebaseUIContainer = el)} />
          </div>
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/containers/Login.js